import React, { useState } from "react";
import {
  MainContext,
  UpdateContext,
  UIContext,
  main,
  configuration,
  uicontext_data,
} from "./main-context.js";
// import "./App.css";
import Home from "./component/Home.js";
import Login from "./component/Login.js";
import { BrowserRouter as Router, Switch, Route } from "react-router-dom";
import Menu from "./component/Menu";
import Alert from "./component/helpers/Alert.js";
import Inspection from "./component/Inspections/Inspection.js";
import { TimeZone } from "./lib/timezone.js";
import Wizard from "./component/Inspections/Wizard/Wizard.js";
import Online from "./component/Online.js";

function App() {
  const [global_state, set_global_state] = useState(main);
  const [ui_state, set_ui_state] = useState(uicontext_data);
  const [update_context] = useState({
    ...configuration,
    update_main_context: set_global_state,
    update_ui_context: set_ui_state,
    time_zone: new TimeZone(),
  });

  return (
    <Router>
      <UIContext.Provider value={ui_state}>
        <MainContext.Provider value={global_state}>
          <UpdateContext.Provider value={update_context}>
            <Alert error={ui_state.error} set_error={set_ui_state} />
            {global_state.status.authorized && (
              <>
                <Switch>
                  <Route
                    path={update_context.settings.subfolder + "/online-only"}
                  >
                    <Online></Online>
                  </Route>
                  <Route>
                    <Menu></Menu>
                    <Switch>
                      <Route
                        path={
                          update_context.settings.subfolder +
                          "/wizard/:type/:id/:operationId"
                        }
                      >
                        <Wizard></Wizard>
                      </Route>
                      <Route
                        path={
                          update_context.settings.subfolder +
                          "/inspections/:type"
                        }
                      >
                        <Inspection />
                      </Route>
                      <Route>
                        <Home />
                      </Route>
                    </Switch>
                  </Route>
                </Switch>
              </>
            )}
            {!global_state.status.authorized && (
              <Route path={update_context.settings.subfolder}>
                <Login />
              </Route>
            )}
          </UpdateContext.Provider>
        </MainContext.Provider>
      </UIContext.Provider>
    </Router>
  );
}

export default App;
